import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

const axiosServices = axios.create({
  baseURL: API_URL,
  withCredentials: true // send HttpOnly cookies on every request
});

// ==============================|| RESPONSE INTERCEPTOR ||============================== //
axiosServices.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;

    if (status === 401 && !originalRequest._retry && !window.location.href.includes('/login')) {
      originalRequest._retry = true;
      try {
        await axios.post(`${API_URL}/api/admin/token_refresh`, {}, { withCredentials: true });
        return axiosServices(originalRequest);
      } catch (err) {
        window.location.href = '/login';
      }
    }

    if (status === 403 && !window.location.href.includes('/login')) {
      window.location.href = '/home';
    }

    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

export default axiosServices;
